import React, { useState } from 'react';
import Modal from '../../basic/Modal';
import QRScanner from './QRScanner';
import useViewEvent from '../../../utils/tracking/useViewEvent';
import { K_AMPLITUDE_EVENT_OPEN_QR_ADDRESS_CODE_SCANNER } from '../../../libs/amplitude/events';

export default function QRScannerModal({ children, onScan }) {
  const [showModal, setShowModal] = useState();
  useViewEvent(K_AMPLITUDE_EVENT_OPEN_QR_ADDRESS_CODE_SCANNER);
  return (
    <React.Fragment>
      <Modal
        open={showModal}
        onClose={() => setShowModal(false)}
        styles={{
          closeIcon: {
            fill: 'red'
          }
        }}
        fullscreen
        center
      >
        <QRScanner
          onScan={result => {
            setShowModal(false);
            onScan(result);
          }}
          style={{ width: '100vmin', maxWidth: '800px' }}
        />
      </Modal>
      {children({ show: () => setShowModal(true) })}
    </React.Fragment>
  );
}
